<app-display-widget
  [title]="item.title"
  [theme]="item.theme"
  [contentTheme]="item.contentTheme"  
  [applyContentBorder]="applyContentBorder"
  [contentOpacity]="item.contentTheme === 'forest-path' ? 10 : 100"
  [useExpandFeatures]="useExpandFeatures"
  [initialExpanded]="isExpanded"
  (expandToggle)="toggleExpanded()"
>
  <div
    class="d-flex flex-column justify-content-center"
    [class.expanded]="isExpanded"
  >
    <div class="content-wrapper" [class.expanded]="isExpanded">
      <p class="font-secondary" [innerHTML]="processedContent"></p>
    </div>
    <app-button *ngIf="item.action !== ''"
      class="text-center"
      variant="default"
      [color]="item.action === 'CHAT NOW' ? 'sunbeam' : 'springleaf'"
      sizeType="fixed"
      fixedSize="xl"
      fontSize="xl"
      [routerLink]="item.routerLink"
      routerLinkActive="active"
      (click)="!item.routerLink && navigateToUrl()"
      >{{ item.action }}</app-button
    >
  </div>
</app-display-widget>
